import { useState, type FC } from "react";
import Nav from "../Nav";
import Header from "../Header";

type Props = {
  children: React.ReactNode;
};

const Layout: FC<Props> = ({ children }) => {
  const [openNav, setOpenNav] = useState(false);

  return (
    <div className="flex h-screen w-dvw">
      <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />
      <div className="h-screen w-dvw overflow-hidden">
        <Header handleOnMenu={() => setOpenNav((prevState) => !prevState)} />
        {children}
      </div>
    </div>
  );
};

export default Layout;
